// extracted by mini-css-extract-plugin
export default {"data_box":"index_data_box_3V8ZQ","devide":"index_devide_Qe813"};